import { render, staticRenderFns } from "./FormChinhSach.vue?vue&type=template&id=b4030ce0&scoped=true&"
import script from "./FormChinhSach.vue?vue&type=script&lang=js&"
export * from "./FormChinhSach.vue?vue&type=script&lang=js&"
import style0 from "./FormChinhSach.vue?vue&type=style&index=0&id=b4030ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4030ce0",
  null
  
)

export default component.exports